import * as React from 'react';
import packageJson from '../../../package.json';
const Health = () => {
    return (
        <>
            <h3>{`Hey There!!! The EMI calculator app is Healthy and version ${packageJson.version}`}</h3>
        </>
    );
};
export default Health;
